<template>
  <div class="commerce-agent-share main">
    <div class="wrapper no-scrollbar">
      <h1 class="header" @click="$emit('close')">
        <i class="fa fa-chevron-left" style="padding-right: 6px" />
        Sharing Your Shop
      </h1>

      <div class="notification is-warning">
        <p class="subtitle">Share Your Shop</p>
        <p style="margin-bottom: 10px">Here's your digital menu link.</p>
        <p class="has-text-link">
          <a :href="urlToMenu">{{ urlToMenu }}</a>
        </p>
        <div class="has-text-right">
          <a class="button" @click="shareYourShop">
            Share your shop&nbsp;
            <i class="fa fa-chevron-right" />
          </a>
        </div>
      </div>

      <div class="notification is-info">
        <p class="subtitle">QR Code Menu</p>
        <p style="margin-bottom: 10px">
          Here's your digital menu QR code.
          <span
            class="tag is-pulled-right"
            :class="{ 'is-warning': showLogo }"
            @click="showLogo = !showLogo"
            >Logo</span
          >
        </p>
        <div
          style="background-color: white; padding: 10px; padding-top: 16px"
          @click="shareQRCode"
        >
          <AnyQRCode
            :url="qrCodeURL"
            :showLogo="showLogo"
            :key="qrCodeURL + showLogo"
          />
        </div>
        <p style="margin-top: 10px">
          You can make a unique dine-in menu QR code for each table.
        </p>
        <div class="has-text-right">
          <a
            v-if="table"
            class="button is-info is-pulled-left has-text-weight-semibold"
          >
            Table: {{ table }}&nbsp;<i
              class="fa fa-times-circle"
              @click="table = null"
            />
          </a>
          <a class="button" @click="makeQRCode">
            Make QR code&nbsp;
            <i class="fa fa-chevron-right" />
          </a>
        </div>
      </div>

      <div class="notification is-primary" @click="shareTUKApp">
        <p class="subtitle">Share TUK</p>
        <p style="margin-bottom: 10px">
          Feel free to share TUK app to your customers and on social media. 🙌🏽
        </p>
        <p>
          The more people that know about TUK the better it is for the
          community.
        </p>
        <div class="has-text-right">
          <a class="button">
            Share TUK App&nbsp;
            <i class="fa fa-chevron-right" />
          </a>
        </div>
      </div>

      <div class="notification is-danger">
        <p class="subtitle" @click="forceUpdate">Need Help?</p>
        <p style="margin-bottom: 10px">
          Send us a chat message and we'll get back to you ASAP.
        </p>
        <div class="has-text-right">
          <a class="button" href="https://m.me/tukapp" target="_blank">
            Chat with us&nbsp;
            <i class="fa fa-chevron-right" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnyQRCode from "@/components/AnyQRCode.vue";

export default {
  name: "CommerceAgentShare",
  components: {
    AnyQRCode,
  },
  props: {
    role: Object,
  },
  data() {
    return {
      table: null, // for qrCodeURL
      showLogo: true,
    };
  },
  computed: {
    business() {
      return this.role.business;
    },
    urlToMenu() {
      var data = this.business.data;
      var link = data.premium_link || data.normal_link;
      return this.hostURL() + link;
    },
    qrCodeURL() {
      if (this.table) return this.urlToMenu + "?a=2&tbl=" + this.table;
      return this.urlToMenu + "?a=1";
    },
  },
  mounted() {},
  methods: {
    forceUpdate() {
      this.clearCacheAndReload();
      this.$emit("close");
    },
    makeQRCode() {
      this.$swal({
        // title: "Make QR Code",
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px; font-size:1.2em'>
        <i class='fa fa-qrcode'></i>&nbsp;Make QR Code
        </p>
        <p style='margin-bottom:10px'>Enter a table number</p>
        <p>For example 1 or A1 or 01</p>
        </div>`,
        input: "text",
        showCloseButton: true,
        confirmButtonText: "Create QR Code",
      }).then((val) => {
        if (val.value) {
          this.table = val.value;
        }
      });
    },
    shareYourShop() {
      this.$copyText(this.urlToMenu);
      this.infoToast("Link Copied", "top"); // copied to clipboard
      if (!navigator.share) {
        console.log("native sharing not supported by this device");
        return;
      }
      var text = `Check out *${this.business.name}* on TUK App 🦜`;
      navigator
        .share({ text: text, url: this.urlToMenu })
        .catch((err) => console.log("Error sharing", err));
    },
    shareQRCode() {
      var msg = `Take a screenshot of the QR code to download it, share it or print it.`;
      this.$swal({
        title: `<i class='fa fa-image fa-2x'></i>&nbsp;&nbsp;<i class='fa fa-print fa-2x'></i>`,
        html: msg,
        showCancelButton: false,
      });
    },
    // inviteOwnDriver() {
    //   var r = this.role;
    //   this.$swal({
    //     title: "Invite a driver to your fleet",
    //     text: `${r.business.name} - ${r.workflow_name} - ${r.role_name}`,
    //     input: "text", //"number",
    //     inputValue: "+66",
    //     showCloseButton: true,
    //     showCancelButton: true,
    //     confirmButtonText: "Invite",
    //     inputValidator: (val) => {
    //       if (!val || val.length < 10) return "You must enter a mobile number!";
    //       if (!this.parsePhoneNumber(val)) return "Invalid phone number!";
    //       var loader = this.loadingDots("orange");
    //       this.$store
    //         .dispatch("createRole", {
    //           phone_number: this.parsePhoneNumber(val),
    //           business_id: r.business_id,
    //           workflow_id: r.workflow_id,
    //           workflow_name: r.workflow_name,
    //           role_type: r.role_type,
    //           role_name: r.role_name,
    //         })
    //         .then(() => this.success())
    //         .catch((err) => this.apiError(err))
    //         .finally(() => loader.hide());
    //     },
    //   });
    // },
    parsePhoneNumber(raw) {
      var numeric = raw.slice(1); // removes any leading +
      if (!/^\d+$/.test(numeric)) return null;
      if (raw[0] === "0") {
        return `+66${raw.substring(1, raw.length)}`; // probably local thai number like 0909588716
      }
      if (raw.substring(0, 4) === "+660") {
        return `+66${raw.substring(4, raw.length)}`; // thai number with extra 0
      }
      if (raw[0] === "+") {
        return raw; // could be correct international number
      }
      return null;
    },
    saveRole(qrPicURL) {
      if (!this.role) {
        this.errorToast("No driver role!");
        return;
      }
      this.role.data.qr_pic_url = qrPicURL;
      var payload = {
        id: this.role.id,
        data: this.role.data,
      };
      this.console("updateRole", payload);
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("updateRoleData", payload)
        .then((res) => {
          console.log("updateRoleData", res);
          this.updateRoles(true);
        })
        .catch((err) => console.error("updateRoleData", err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  max-width: 600px;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.95);
  z-index: 21;
  /* z-index: 1100; */
  /* random z-index higher than modal */
  backdrop-filter: blur(3px);
  overflow: hidden;
}
.wrapper {
  padding: 12px;
  text-align: left;
  height: 100vh;
  overflow: auto;
}
.header {
  font-size: 1.3em;
  font-weight: 450;
  margin-top: 4px;
  margin-bottom: 12px;
}
.subtitle {
  opacity: 0.7;
  font-weight: 450;
  margin-bottom: 14px;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}
p {
  margin-bottom: 10px;
}
.notification {
  padding: 12px 16px;
  margin-bottom: 10px;
}
</style>